import type {
  ReportFilterStateV1,
  ReportMetricId,
  VideoMetricRow,
} from "@meta-video/contracts";

import type { ReportApi } from "./api.js";
import { VideoAdsPanel } from "./VideoAdsPanel.js";

export interface DrilldownRowProps {
  readonly api: ReportApi;
  readonly columnIds: readonly ReportMetricId[];
  readonly expectedFingerprint?: string;
  readonly filters: ReportFilterStateV1;
  readonly onAccessChanged?: () => void;
  readonly onSessionExpired?: () => void;
  readonly row: VideoMetricRow;
  readonly videoMetricCoverageThreshold: number;
}

export function DrilldownRow({
  api,
  columnIds,
  expectedFingerprint,
  filters,
  onAccessChanged,
  onSessionExpired,
  row,
  videoMetricCoverageThreshold,
}: DrilldownRowProps) {
  return (
    <VideoAdsPanel
      api={api}
      columnIds={columnIds}
      expectedFingerprint={expectedFingerprint}
      filters={filters}
      onAccessChanged={onAccessChanged}
      onSessionExpired={onSessionExpired}
      selection={{ brandId: row.brandId, videoId: row.videoId }}
      videoMetricCoverageThreshold={videoMetricCoverageThreshold}
    />
  );
}
